module.exports = __webpack_public_path__ + "static/img/payme-hd.209d137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payme-hd.png
// module id = j6aM
// module chunks = 1